import { useContext, useEffect, useState } from "react";
import { Button, Col, Container, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import Header from "../../../components/Headers/Header";
import AdminNavbar from "../../../components/Navbars/AdminNavbar/AdminNavbar";
import "./SearchCandidates.css";
import CardCandidate from "../../../components/CardCandidate/CardCandidate";
import ModalComponentRecruiter from "../../../components/ModalComponentRecruiter/ModalComponentRecruiter";
import { CandidateContext } from "../../../context/CandidateContext";
import calculateAge from "../../../utils/calculateAge";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import PaginationMaterial from "../../../components/PaginationMaterial/PaginationMaterial";
import _ from "lodash";
import WhatsappButton from "../../../components/WhatsappButtom/WhatsappButtom";
import { CandidateType } from "../../../context/hooks/useCandidate";
import { AuthContext } from "../../../context/AuthContext";
import { FavoriteContext } from "../../../context/FavoriteContext";

const SearchCandidates = () => {
  const [loading, setLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [dataSearch, setDataSearch] = useState({input1: "", input2: "", state: "", educationStatus: "", age: 0, hasCar: false, hasPCD: false, distance: 0, cityReference: ""});
  const [showOnlyFavorites, setShowOnlyFavorites] = useState<boolean>(false);
  const [legendModal, setLegendModal] = useState(false);
  const { objUserTk } = useContext(AuthContext);
  const { handleGetByUserId } = useContext(FavoriteContext);
  const [paginationMain, setPaginationMain] = useState({
    initial: 0,
    final: 9,
  });

  const [paginationCommon, setPaginationCommon] = useState({
    initial: 0,
    final: 9,
  });
  
  const [paginationFavorite, setPaginationFavorite] = useState({
    initial: 0,
    final: 9,
  });

  const [favoriteCandidates, setFavoriteCandidates] = useState<CandidateType[]>([]);
  const {
    handleGetByCandidateId,
    listCandidate,
    setCandidate,
    setListCandidate,
    initialListCandidate,
    getAllCandidatesPaged,
    pageCount,
    setPageCount,
    handleGetFavoriteCandidateAPI,
    downloadCandidateReport,
  } = useContext(CandidateContext);

  const listCandidateMain = listCandidate.filter((e) => e.typeCandidate === 1); 
  const listCandidateCommon = listCandidate.filter(
    (e) => e.typeCandidate === 0
  ); //comum

  const handleGetUserDetails = (idCandidate: number) => {
    var cardCandidate = handleGetByCandidateId(idCandidate);
    setCandidate(cardCandidate);
    setOpenModal((prevState) => !prevState);
  };
  
  const onChangePaginationCommon = async (e: any, value: any) => {
    
    await getAllCandidatesPaged(value, dataSearch.input2, dataSearch.input1, dataSearch.educationStatus, dataSearch.age, dataSearch.hasCar, dataSearch.hasPCD, dataSearch.distance, dataSearch.state, dataSearch.cityReference);
  };

  const handleSearchCandidate = async (data: any) => {
    if (data.input1 || data.input2 || data.educationStatus || data.age || data.hasCar || data.hasPCD || data.distance || data.state || data.cityReference) {
      setDataSearch({input1: data.input1, input2: data.input2, educationStatus: data.educationStatus, age: data.age,hasCar: data.hasCar, hasPCD: data.hasPCD, distance: data.distance, state: data.state, cityReference: data.cityReference});
      await getAllCandidatesPaged(1, data.input2, data.input1, data.educationStatus, data.age,data.hasCar, data.hasPCD, data.distance, data.state, data.cityReference);
    }
  };

  useEffect(() => {
    setLoading(false);
    getAllCandidatesPaged(1);
    
    if (objUserTk.UserId) {
      handleGetByUserId(objUserTk.UserId)
        .then((favoriteData) => {
          if (favoriteData) {
            localStorage.setItem('favoriteCandidates', JSON.stringify(favoriteData.listFavoriteCandidates) || '[]');
            localStorage.setItem('rejectedCandidates', JSON.stringify(favoriteData.listRejectedCandidates) || '[]');
          }
        })
        .catch((error) => {
          console.error('Erro ao obter dados favoritos:', error);
        });
    }
  }, []);

  useEffect(() => {
    if (showOnlyFavorites) {
      handleGetFavoriteCandidates();
    } else {
      getAllCandidatesPaged(1);
    }
  }, [showOnlyFavorites]); 

  const handleGetFavoriteCandidates = async () => {
    try {
      const favoriteIds = JSON.parse(localStorage.getItem(`favoriteCandidates`) || '[]');
      if (favoriteIds.length > 0) {
        const favorites = await handleGetFavoriteCandidateAPI(favoriteIds); 
        setFavoriteCandidates(favorites || []); 
      }
    } catch (error) {
      console.error("Erro ao obter candidatos favoritos:", error);
    }
  };

  const handleToggleShowOnlyFavorites = () => {
    const newShowOnlyFavorites = !showOnlyFavorites;
    setShowOnlyFavorites(!showOnlyFavorites);
    localStorage.setItem('showOnlyFavorites', JSON.stringify(newShowOnlyFavorites));
  };

  const handleDownloadReport = () => {
    const favoriteIds = JSON.parse(localStorage.getItem('favoriteCandidates') || '[]');
    downloadCandidateReport(
      dataSearch.input2,
      dataSearch.input1,
      dataSearch.educationStatus,
      dataSearch.age,
      dataSearch.hasCar,
      dataSearch.hasPCD,
      dataSearch.distance,
      dataSearch.state,
      dataSearch.cityReference,
      favoriteIds
    );
  };

  const onChangePaginationFavorite = async (e: any, value: any) => {
    await handleGetFavoriteCandidates();
    const positionInitial = (value - 1) * 9;
    const positionFinal = positionInitial + 9;
    setPaginationFavorite({ initial: positionInitial, final: positionFinal });
  };
  

  return (
    <>
      <WhatsappButton />
      <LoadingSpinner />
      <Header />
      <AdminNavbar
        placeholderSearch="Nome"
        placeholderSearch1="Descrição"
        titleButtonSearch="PROCURAR"
        brandText={"PROCURAR CANDIDATOS"}
        search={false}
        titleSearch={""}
        handleButtonSearch={handleSearchCandidate}
        showAdvancedFilters={true}
      />

      <Container className="mt--7" fluid>
        
        {/* <Card
          className="shadow cards-filters-jobs"
          style={{ marginTop: "60px" }}
        >
          <CardHeader className="bg-transparent d-flex justify-content-center">
            <div className="d-flex" style={{ gap: "15px" }}>
            </div>
          </CardHeader>
        </Card> */}

        <div className="title-row-card-candidate mt-8">
          {/* {listCandidateMain.length > 0 ? "Destaque" : ""} */}
          {""}
        </div>

        {/*
        {listCandidateMain.length > 0 && (
          <Row className="line-cards-candidate-container">
              {listCandidateMain
                .slice(paginationMain.initial, paginationMain.final)
                .map((item: any) => {
                  return (
                    <Col sm="6" xl="4" key={item.id}>
                      <CardCandidate
                        handleGetUserDetails={() =>
                          handleGetUserDetails(item.id)
                        }
                        id={item.id}
                        imgProfile={
                          item.photo ||
                          require("../../../assets/img/theme/profile.png")
                        }
                        cityCandidate={item.city}
                        distanceCandidate={""}
                        detailsCandidate={item.description}
                        experinceCandidate={item.expertises?.[0]?.title || ""}
                        experinceCandidate2={item.expertises?.[1]?.title || ""}
                        infoCandidate={`${item.name}, ${calculateAge(
                          item.birthData
                        )} anos`}
                      />
                    </Col>
                  );
                })}
          </Row>
        )} */}

        {/* {pageCount > 3 && (
          <div className="d-flex justify-content-center mt-4">
            <PaginationMaterial
              onChange={onChangePaginationMain}
              count={Math.ceil(pageCount / 3 || 0)}
            />
          </div>
        )} */}

        {/* <div className="title-row-card-candidate">Candidatos de Primeira</div> */}
        
        <div className="title-row-card-candidate mt-8 d-flex align-items-center">
          <div className="mr-auto">Candidatos de Primeira</div>
          <div className="d-flex align-items-center" style={{ gap: '1.25rem' }}>
            <Button
              size="sm"
              outline
              onClick={() => setLegendModal(true)}
              className="d-flex align-items-center"
              style={{
                color: '#3a8f7e',
                borderColor: '#4db7a2',
                fontWeight: 600,
              }}
            >
              <i className="fas fa-medal mr-2" /> Jornada do aluno
            </Button>
            <div className="filter-favorites">
              <input
                type="checkbox"
                checked={showOnlyFavorites}
                onChange={handleToggleShowOnlyFavorites}
              />
              <span> Mostrar apenas favoritos</span>
            </div>
            {showOnlyFavorites && (
              <Button
                color="success"
                size="sm"
                className="d-flex align-items-center"
                onClick={handleDownloadReport}
                style={{ fontWeight: 600, whiteSpace: 'nowrap', boxShadow: '0 2px 6px rgba(40, 167, 69, 0.4)' }}
              >
                <i className="fas fa-file-excel mr-2" /> Exportar resultados
              </Button>
            )}
          </div>
        </div>

        <Row className="line-cards-candidate-container">
            {(showOnlyFavorites ? favoriteCandidates.slice(paginationFavorite.initial, paginationFavorite.final) : listCandidate.slice(paginationCommon.initial, paginationCommon.final))
            .map((item: any) => {
              return (
                <Col sm="6" xl="4" key={item.id} className="mb-3">
                  <CardCandidate
                    handleGetUserDetails={() => handleGetUserDetails(item.id)}
                    id={item.id}
                    imgProfile={
                      item.photo ||
                      require("../../../assets/img/theme/profile.png")
                    }
                    cityCandidate={item.city}
                    stateCandidate={item.state}
                    distanceCandidate={""}
                    detailsCandidate={item.description}
                    // experinceCandidate={item.expertises?.[0]?.title || ""}
                    // experinceCandidate2={item.expertises?.[1]?.title || ""}
                    personalGoal={item.personalGoal}
                    tier={item.tier}
                    infoCandidate={`${item.name}, ${calculateAge(
                      item.birthData
                    )} anos`}
                  />
                </Col>
              );
            })}
        </Row>

        {pageCount && (
          <div className="d-flex justify-content-center mt-4">
            <PaginationMaterial
              onChange={(e: any, value: any) => (showOnlyFavorites ? onChangePaginationFavorite(e, value) : onChangePaginationCommon(e, value))}
              count={showOnlyFavorites ? Math.ceil(favoriteCandidates.length / 9 || 0) : pageCount}
            />
          </div>
        )}

        {listCandidateCommon.length === 0 && (
          <div style={{ color: "red" }}>ENCONTRADO NENHUM REGISTRO</div>
        )}
      </Container>
      <ModalComponentRecruiter
        openModal={openModal}
        closeModal={() => setOpenModal((state) => !state)}
      />

      <Modal size="lg" isOpen={legendModal} toggle={() => setLegendModal(false)}>
        <ModalHeader toggle={() => setLegendModal(false)}>
          Legenda de Classificação dos Candidatos
        </ModalHeader>
        <ModalBody>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #dee2e6' }}>
                <th style={{ padding: '8px', textAlign: 'left' }}>Classificação</th>
                <th style={{ padding: '8px', textAlign: 'left' }}>Perfil</th>
                <th style={{ padding: '8px', textAlign: 'left' }}>Curso</th>
                <th style={{ padding: '8px', textAlign: 'left' }}>Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '10px 8px' }}>
                  <span style={{ color: '#CD7F32', fontWeight: 600, whiteSpace: 'nowrap' }}>🥉 Bronze</span>
                </td>
                <td style={{ padding: '10px 8px' }}>Club PdP Start</td>
                <td style={{ padding: '10px 8px' }}>Club PdP Start</td>
                <td style={{ padding: '10px 8px', color: '#666', fontSize: '13px' }}>Busca conhecimento sobre a indústria farmacêutica</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '10px 8px' }}>
                  <span style={{ color: '#A8A9AD', fontWeight: 600, whiteSpace: 'nowrap' }}>🥈 Prata</span>
                </td>
                <td style={{ padding: '10px 8px' }}>Formação inicial</td>
                <td style={{ padding: '10px 8px' }}>Método REP</td>
                <td style={{ padding: '10px 8px', color: '#666', fontSize: '13px' }}>Rota, Estratégia e Performance na Propaganda Médica</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '10px 8px' }}>
                  <span style={{ color: '#FFD700', fontWeight: 600, whiteSpace: 'nowrap' }}>🥇 Ouro</span>
                </td>
                <td style={{ padding: '10px 8px' }}>Formação padrão</td>
                <td style={{ padding: '10px 8px' }}>Método FPP</td>
                <td style={{ padding: '10px 8px', color: '#666', fontSize: '13px' }}>Extensão Universitária Formação Propagandista de Primeira</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: '10px 8px' }}>
                  <span style={{ color: '#4FC3F7', fontWeight: 600, whiteSpace: 'nowrap' }}>💎 Diamante</span>
                </td>
                <td style={{ padding: '10px 8px' }}>Formação avançada</td>
                <td style={{ padding: '10px 8px' }}>MBA FRAPP</td>
                <td style={{ padding: '10px 8px', color: '#666', fontSize: '13px' }}>Pós-Graduação Formação e Resultado de Alta Performance na Propaganda Médica</td>
              </tr>
              <tr>
                <td style={{ padding: '10px 8px' }}>
                  <span style={{ color: '#D4AF37', fontWeight: 600, whiteSpace: 'nowrap' }}>👑 Elite</span>
                </td>
                <td style={{ padding: '10px 8px' }}>Formação de elite</td>
                <td style={{ padding: '10px 8px' }}>MBA FRAPP + RCPM</td>
                <td style={{ padding: '10px 8px', color: '#666', fontSize: '13px' }}>Junção da Pós-Graduação MBA FRAPP com o RCPM</td>
              </tr>
            </tbody>
          </table>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SearchCandidates;
